// Mar 2026 v41 Step 3 — Customer-facing PFA scope summary.
// Renders scope label + associated categories/products as compact chips.
// Reads directly from the enriched customer payload (name/display_name,
// scope_type, categories[], products[]).
import React from "react";
import { Badge } from "../design-system";

const SCOPE_LABEL = {
  GLOBAL: "Generale",
  CATEGORY: "Per categoria",
  PRODUCT: "Per articoli",
};

const chipStyle = {
  display: "inline-flex", alignItems: "center",
  background: "#EFF6FF", color: "#1E3A8A",
  padding: "2px 8px", borderRadius: 10, fontSize: 11,
  marginRight: 4, marginBottom: 4,
  whiteSpace: "nowrap", maxWidth: "100%", overflow: "hidden",
  textOverflow: "ellipsis",
};

export function PfaScopeSummary({ pfa, maxChips = 4, testidPrefix = "pfa-scope" }) {
  const scope = pfa?.scope_type || pfa?.scope || "GLOBAL";
  const label = SCOPE_LABEL[scope] || "Generale";
  const cats = pfa?.categories || [];
  const prods = pfa?.products || [];
  const items = scope === "CATEGORY"
    ? cats.map((c) => c.name || "").filter(Boolean)
    : scope === "PRODUCT"
      ? prods.map((p) => (p.sku ? `${p.sku} — ${p.name || ""}` : (p.name || ""))).filter(Boolean)
      : [];
  const shown = items.slice(0, maxChips);
  const rest = items.length - shown.length;
  return (
    <div data-testid={`${testidPrefix}-summary`} style={{ marginTop: 4 }}>
      <Badge tone={scope === "PRODUCT" ? "success" : scope === "CATEGORY" ? "info" : "neutral"}
             data-testid={`${testidPrefix}-badge`}>
        {label}
      </Badge>
      {items.length > 0 && (
        <div style={{ marginTop: 6, display: "flex", flexWrap: "wrap" }}
             data-testid={`${testidPrefix}-chips`}>
          {shown.map((s, i) => (
            <span key={i} style={chipStyle} title={s}>{s}</span>
          ))}
          {rest > 0 && (
            <span style={{ ...chipStyle, background: "#F1F5F9", color: "#475569" }}
                  data-testid={`${testidPrefix}-more`}>
              + altri {rest}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
